import { render, staticRenderFns } from "./EvaluationRecruitmentGravityPage.vue?vue&type=template&id=856b54d8&"
import script from "./EvaluationRecruitmentGravityPage.vue?vue&type=script&lang=js&"
export * from "./EvaluationRecruitmentGravityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports